module.exports = __webpack_public_path__ + "static/media/imgSelfProductionBenefits1.99fa130a.png";